import { Dispatch, FC, PropsWithChildren, SetStateAction, createContext, useContext, useState } from 'react';

type ImageContextType = {
  preview?: string;
  webcam: boolean;
  setPreview: Dispatch<SetStateAction<string | undefined>>;
  setWebcam: Dispatch<SetStateAction<boolean>>;
};

const ImageContext = createContext<ImageContextType>({
  webcam: false,
  setPreview: () => {},
  setWebcam: () => {}
});

export const useImages = () => useContext(ImageContext);

export const ImagesProvider: FC<PropsWithChildren> = ({ children }) => {
  const [preview, setPreview] = useState<string>();
  const [webcam, setWebcam] = useState(false);

  return <ImageContext.Provider value={{ preview, webcam, setPreview, setWebcam }}>{children}</ImageContext.Provider>;
};
